import { t } from "i18next"
import { useCallback } from "react"
import { framesToSeconds, secondsToFrames } from "../helpers/framerate.helpers"
import { useAppSelector } from "./useRedux"

const useFramerate = () => {
    const framerate = useAppSelector((state) => state.timelinePreferences.value.framerate)

    const resultTimeFramerate = useCallback(
        (time: number) => secondsToFrames(framerate, time),
        [framerate]
    )

    const setFramerateValue = (value: number) => framesToSeconds(framerate, value)

    const getInputAdornment = () => {
        switch (framerate) {
            case 50:
                return t("editor:inputAdornmentUnit.fps")
            case 25:
                return t("editor:inputAdornmentUnit.fps")
            default:
                return t("editor:inputAdornmentUnit.sec")
        }
    }

    return {
        framerate,
        setFramerateValue,
        resultTimeFramerate,
        getInputAdornment,
    }
}

export default useFramerate
